import { render, staticRenderFns } from "./DeviationSection.vue?vue&type=template&id=864845c2&scoped=true&"
import script from "./DeviationSection.vue?vue&type=script&lang=js&"
export * from "./DeviationSection.vue?vue&type=script&lang=js&"
import style0 from "./DeviationSection.vue?vue&type=style&index=0&id=864845c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864845c2",
  null
  
)

export default component.exports